import { render } from "./Notifications.vue?vue&type=template&id=3a9528fc&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=3a9528fc&scoped=true&lang=scss"
import "./Notifications.vue?vue&type=style&index=1&id=3a9528fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9528fc"]])

export default __exports__